<template>
    <div>
        <Breadcrumbs main="" title="bookingTx.header" />
        <b-container fluid>
            <div class="d-flex flex-row justify-content-between mr-5">
                <h2 class="mb-1 mt-4 f-w-600">{{ $t('bookingTx.header') }}</h2>
                <div class="row">
                    <router-link to="/dashboard/homePageAgent">
                        <feather  v-b-tooltip.hover :title="$t('homePageAgent.header')" type="home" class="mx-2"></feather>
                    </router-link>
                    <router-link to="/dashboard/shipApproval">
                        <feather  v-b-tooltip.hover :title="$t('homePageAgent.matching')" type="link" class="mx-2"></feather>
                    </router-link>
                    <router-link to="/process/shipShore">
                        <feather  v-b-tooltip.hover :title="$t('homePageAgent.shoreApproval')" type="tag" class="mx-2"></feather>
                    </router-link>
                </div>
            </div>
            <div>
                <b-row>
                <b-col lg="5" class="my-1">
                    <b-form-group
                    :label="$t('matchTx.sort')"
                    label-for="sort-by-select"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="lg"
                    class="mb-0"
                    v-slot="{ ariaDescribedby }"
                    >
                    <b-input-group size="lg">
                        <b-form-select
                        id="sort-by-select"
                        v-model="sortBy"
                        :options="sortOptions"
                        :aria-describedby="ariaDescribedby"
                        class="w-70 text-info"
                        >
                        <template #first>
                            <option value="">-- none --</option>
                        </template>
                        </b-form-select>
    
                        <b-form-select
                        v-model="sortDesc"
                        :disabled="!sortBy"
                        :aria-describedby="ariaDescribedby"
                        size="lg"
                        class="w-30 text-info"
                        >
                        <option :value="false">{{$t('matchTx.asc')}}</option>
                        <option :value="true">{{$t('matchTx.desc')}}</option>
                        </b-form-select>
                    </b-input-group>
                    </b-form-group>
                </b-col>
    
                <b-col lg="5" class="my-1">
                    <b-form-group
                    :label="$t('matchTx.initSort')"
                    label-for="initial-sort-select"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="lg"
                    class="mb-0"
                    >
                    <b-form-select
                        id="initial-sort-select"
                        v-model="sortDirection"
                        :options="['asc', 'desc', 'last']"
                        size="lg"
                        class="text-info"
                    ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="5" class="my-1">
                    <b-form-group
                    :label="$t('matchTx.filter')"
                    label-for="filter-input"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="lg"
                    class="mb-0"
                    >
                    <b-input-group size="sm">
                        <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        :placeholder="$t('matchTx.typeToSearch')"
                        class="text-info"
                        style="font-size: 18px;"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                            {{ $t('matchTx.clear') }}
                        </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col lg="5" class="my-1">
                    <b-form-group
                    v-model="sortDirection"
                    :label="$t('matchTx.filterOn')"
                    :description= "$t('matchTx.uncheck')"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="lg"
                    class="mb-0"
                    v-slot="{ ariaDescribedby }"
                    >
                    <b-form-checkbox-group
                        v-model="filterOn"
                        :aria-describedby="ariaDescribedby"
                        class="mt-1 text-info"
                        plain
                    >
                        <b-form-checkbox value="commodity">{{ $t('getQuote.commodity') }}</b-form-checkbox>
                        <b-form-checkbox value="fghtCat">{{ $t('freight.cat') }}</b-form-checkbox> 
                        <b-form-checkbox value="POL">{{ $t('getQuote.POL') }}</b-form-checkbox>         
                        <b-form-checkbox value="POD">{{ $t('getQuote.POD') }}</b-form-checkbox>     
                    </b-form-checkbox-group>
                    </b-form-group>
                </b-col>
                </b-row>
                <div class="row justify-content-start ml-2">
                    <feather 
                        @click="refreshBookingTx" 
                        class="text-primary" 
                        type="refresh-cw"  
                        size="25" 
                        v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
                    </feather>  
                    <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
                    <span class="text-primary"> {{ asOf }} </span>   
                </div>
                <b-table
                    sticky-header
                    show-empty
                    bordered
                    responsive
                    sort-icon-left
                    stacked="md"
                    :busy="isBusy"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                <!-- <template #thead-top="">
                <b-tr>
                    <b-th colspan="2"><span class="sr-only">mTxId and BkgId</span></b-th>
                    <b-th variant="info" colspan="7" class="tableInfo">{{ $t('matchTx.contInfo') }}</b-th>
                    <b-th colspan="2"><span class="sr-only">sealShip</span></b-th>
                    <b-th variant="danger" colspan="3" class="tableInfo">{{ $t('matchTx.jobStatusMtx') }}</b-th>
                    <b-th colspan="2"><span class="sr-only"></span></b-th>
                    <b-th variant="success" colspan="4" class="tableInfo">{{ $t('release.header') }}</b-th>
                    <b-th variant="primary" colspan="4" class="tableInfo">{{ $t('require.header') }}</b-th>
                    <b-th variant="warning" colspan="3" class="tableInfo">{{ $t('matchTx.transportation') }}</b-th>
                </b-tr>
                </template> -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(detailsPOL)="row" >
                        <b-button size="sm" @click="openModalDetailsPOL(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                            {{ row.item.POL}}
                        </b-button>
                    </template>
                    <template #cell(detailsPOD)="row" >
                        <b-button size="sm" @click="openModalDetailsPOD(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                            {{ row.item.POD}}
                        </b-button>
                    </template>
                    <template #cell(jbBTx)="row" >
                    <b-button  size="sm" @click="openModalJbBTx(row.item )" variant="outline-dark" v-b-popover.hover.top="$t('matchTx.jobStatusDetails')">
                        {{ $t('bookingTx.' + (row.item.jbBTx || 'default')) }}
                    </b-button>
                    </template>
                    <template #cell(detailsCommodity)="row" >
                        <b-button size="sm" @click="openModalDetailsCommodity(row.item )" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsCommodity')">
                            {{ row.item.commodity}}
                        </b-button>
                    </template>    
                    <template #cell(contSQWArr)="row" >
                        <div
                        v-for="(sqw, index) in row.item.contSQW"
                        :key="index"
                        class="select-group-sqw"
                        >
                        <span class="ml-2"># {{index + 1}}:</span>         
                        <span class="ml-2">{{ sqw.contSize}} - </span>       
                        <span>{{ sqw.contQty}} - </span>      
                        <span>{{ sqw.cargoKg}} </span>      
                        </div>
                    </template>                
                    <template #cell(detailsFght)="row" >
                        <b-button size="sm" @click="openModalDetailsFght(row.item, row.index, $event.target )"  style="font-size:16px" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsFght')">
                            {{ row.item.fUSD.toFixed(0)}}
                        </b-button>
                    </template>
                    <template #cell(detailsSur)="row" >
                        <b-button size="sm" @click="openModalDetailsSur(row.item, row.index, $event.target )"  style="font-size:16px" variant="outline-dark" v-b-popover.hover.top="$t('getQuote.detailsSur')">
                            {{ row.item.surUSD.toFixed(0)}}
                        </b-button>
                    </template>          
                    <template #cell(actCust)="row" >
                    <b-button-group>
                        <b-button class="m-1 text-dark" v-show="row.item.actAgent.preQInfo" size="sm" variant="light" @click="actPreQInfo(row.item)" v-b-popover.hover.top="$t('bookingTx.preQInfoMsg')">
                        {{ $t('bookingTx.preQInfo') }}
                        </b-button>   
                        <b-button class="m-1 " v-show="row.item.actAgent.msgr" pill size="sm" variant="primary" @click="actMsgr(row.item)" v-b-popover.hover.top="$t('bookingTx.msgrMsg')">
                        {{ $t('bookingTx.messenger') }}
                        </b-button>                                 

                    </b-button-group>
                    <b-button-group>
                        <b-button class="m-1" v-show="row.item.actAgent.accept" size="sm" variant="success" @click="actAccept(row.item )" v-b-popover.hover.top="$t('bookingTx.acceptMsg')">
                        {{ $t('bookingTx.accept') }}
                        </b-button>                    
                        <b-button class="m-1" v-show="row.item.actAgent.reject" size="sm" variant="danger" @click="actReject(row.item)" v-b-popover.hover.top="$t('bookingTx.rejectMsg')">
                        {{ $t('matchTx.reject') }} 
                        </b-button>                         
                    </b-button-group>
                    <b-button-group>
                        <b-button class="m-1" v-show="row.item.actAgent.agentQ" size="sm" variant="dark" @click="actAgentQ(row.item)" v-b-popover.hover.top="$t('bookingTx.agentQMsg')">
                        {{ $t('bookingTx.quote') }}
                        </b-button>
                        <b-button class="m-1" v-show="row.item.actAgent.agentB" size="sm" variant="dark" @click="actAgentB(row.item)" v-b-popover.hover.top="$t('bookingTx.agentBMsg')">
                        {{ $t('bookingTx.booking') }}
                        </b-button>
                    </b-button-group>
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-4 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
                <div>
                    <b-modal id="jbBTxModal" :title="$t('matchTx.jobStatusDetails')"  title-tag="h3" size="lg" ok-only @hide="resetModalJbBTx">
                    <div v-for="(item , index) in jbBTx" :key="index" class="my-loop-item">
                    <div class="row">
                    <h4 class="ml-2 my-1">&gt;</h4>
                    <span class="ml-2 my-1">{{ $moment(item.timestamp).format("DD-MM-YY @ HH:mm") }}</span>
                    <span class="ml-2 my-1"> {{ $t(`jbBTx.${item.jbBTx}`)  }}</span>
                    </div>
                    </div>
                    </b-modal>
                    <b-modal id="msgrModal" :title="`${$t('bookingTx.msgrDetails')} : ${selAgent}`" title-tag="h3" hide-footer size="lg" @hide="resetModalMsgr">
                    <div v-for="(item , index) in msgr" :key="index" class="my-loop-item">
                        <div class="row m-2">
                        <h4 class="ml-2 my-1">&gt;</h4>
                        <span class="ml-2 my-1">{{ $moment(item.timestamp).format("DD-MM-YY @ HH:mm") }}</span>
                        <span class="ml-2 my-1 text-primary"> {{ item.msgr }}</span>
                        </div>
                    </div>
                    <div class="card mx-2 mt-3 gradient-wb ">
                        <b-row>
                        <b-col sm="1" class="mt-3">
                            <span class="text-primary f-w-800 ml-3" style="font-size:50px;">&rsaquo;</span>
                        </b-col>
                        <b-col sm="10">
                            <b-form-textarea
                            id="msgrInput"
                            v-model="msgrInput"
                            :placeholder="$t('bookingTx.msgrInput2CustPh')"
                            rows="3"
                            max-rows="8"
                            ></b-form-textarea>
                        </b-col>
                        <b-col sm="1" class="mt-3">
                            <span v-show="msgrInput" class="text-white f-w-800" style="font-size:60px; font-weight: bold; cursor: pointer" @click="clickSend_Msgr">&rsaquo;</span>
                        </b-col>
                        </b-row>
                    </div>
                    </b-modal>
                    <b-modal id="detailsCommodityModal" :title="$t('getQuote.commodity')" title-tag="h4" size="md" ok-only @hide="resetModalDetailsCommodity">
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('getQuote.commodity') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{commodity }}</h3>
                        </div>   
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('getQuote.dgGds') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{$t(`getQuote.${dgGDs}`) }}</h3>
                        </div>                
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('hsCode.HS') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{ hs6 }}</h3>
                        </div>
                    </b-modal>
                    <b-modal id="detailsPortModal" :title="$t('freight.detailsPort')" title-tag="h4"  size="md" ok-only @hide="resetModalDetailsPort">
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('port.portId') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{this.portId }}</h3>
                        </div>   
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('port.pName') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{this.pName }}</h3>
                        </div>                
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('port.cntry') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{ this.cntry }}</h3>
                        </div>
                    </b-modal>
                    <b-modal id="detailsFghtModal" :title="$t('getQuote.detailsFght')" title-tag="h4"  size="md" ok-only @hide="resetModalDetailsFght">
                        <b-table
                            sticky-header
                            head-variant="dark"
                            show-empty
                            bordered
                            responsive
                            sort-icon-left
                            stacked="md"
                            :items="itemsFght"
                            :fields="fieldsFght"
                        >
                            <template #empty>
                                <h5>{{ $t('reuse.noRecord') }}</h5>
                            </template>
                        </b-table>
                    </b-modal>
                    <b-modal id="detailsSurModal" :title="$t('getQuote.detailsSur')" title-tag="h3"  size="lg"  ok-only @hide="resetModalDetailsFght">
                        <b-table
                            sticky-header
                            head-variant="dark"
                            show-empty
                            bordered
                            responsive
                            sort-icon-left
                            stacked="md"
                            :items="itemsSur"
                            :fields="fieldsSur"
                        >
                            <template #empty>
                                <h5>{{ $t('reuse.noRecord') }}</h5>
                            </template>
                            <template #cell(detailsSurCode)="row" >
                                <b-button size="sm" @click="openModalDetailsSurCode(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('surcharge.detailsSurCode')">
                                    {{ row.item.surCode}}
                                </b-button>
                            </template>
                        </b-table>
                    </b-modal>
                    <b-modal id="detailsSurCodeModal" :title="$t('surcharge.detailsSurCode')" title-tag="h4"  size="md" ok-only @hide="resetModalDetailsSurCode">
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('surcharge.surCode') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{this.selectedSurCode }}</h3>
                        </div>   
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('surcharge.surDesc') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{this.surDesc }}</h3>
                        </div>                
                        <div class="row ml-2">
                            <h3 class="mt-3"> {{ $t('slip.remark') }} :</h3>
                            <h3 class="mt-3 ml-2 text-info"> {{ this.remark}}</h3>
                        </div>
                    </b-modal>
                    <b-modal id="rejAgentModal" header-text-variant="danger" title-tag="h3" :title="$t('bookingTx.rejAgentTitle')" size="md" hide-footer @hide="resetModalRejAgent">
                        <div class="card m-2 gradient-wy ">
                        <h3> {{ $t('bookingTx.confirmRejectMsg') }}</h3>
                        </div>
                        <div class="m-2 gradient-wb ">
                            <label for="mgrsInput" class="col-form-label pt-0 f-w-600 ml-2" style="font-size:16px;"> {{ $t("bookingTx.msgrRejAgent") }}</label>                                                                       
                            <b-form-input class="mx-2" style="font-size:16px;" v-model="msgrInput" type = "text" :placeholder="$t('bookingTx.msgrRejectPh')">                            
                            </b-form-input>
                            <b-form-radio-group
                                class="mt-2"
                                v-model="selectedReason"
                                :options="rejAgentOptions"
                                @input = "msgrInput = selectedReason" 
                                plain
                                size="md"
                            ></b-form-radio-group>
                        </div>
                        <div class="row col-sm-12 ">
                            <div class="col-sm-5 m-4">
                                <b-button variant="warning" style="font-size:20px" @click="resetModalRejAgent">{{ $t('matchTx.no') }}</b-button>
                            </div>                
                            <div class="col-sm-4 m-4">
                                <b-button variant="danger" style="font-size:20px" @click="clickYes_RejAgent">{{ $t('matchTx.yes') }}</b-button>
                            </div>
                        </div>
                    </b-modal>
                    <b-modal id="acceptAgentModal" 
                        hide-footer 
                        variant="info" 
                        title-tag="h3"  
                        size="lg" 
                        :title="$t('bookingTx.acceptAgentTitle')" 
                        @hide="resetModalAcceptAgent"
                    >
                        <h3 class="text-primary mx-3">{{ $t('bookingTx.acceptAgentMsg') }}</h3>
                        <div>
                            <label for="docNo" class="col-form-label pt-0 f-w-600 ml-2" style="font-size:16px;"> {{  $t('bookingTx.docNoQ') }}</label>                                                                       
                            <b-form-input class="mx-2" style="font-size:16px;" v-model="docNo" type = "text" :placeholder="$t('bookingTx.docNoPh')">                            
                            </b-form-input>                        
                        </div>
                        <div class="row col-sm-12"> 
                            <div class=" card">
                                <div class="top">
                                    <span class="text-primary" style="font-size: 20px;">{{ $t('bookingTx.dragDropQ') }}</span>
                                </div>
                                <div class="drag-area" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">  
                                    <span class="text-info" v-if="!isDragging">
                                        {{ $t('bookingId.dragDropHere') }}
                                            <span class="select" role="button" @click="selectFiles">
                                            {{ $t('bookingId.choose') }}
                                            </span>
                                    </span>
                                    <div v-else class="select">{{ $t('bookingId.dropHere') }}</div>
                                    <input name="file" type="file" accept="application/pdf, image/png, image/jpg" class="file" ref="fileInput" @change="onFileSelect"/>
                                    <!-- <input name="file" type="file" accept="application/pdf" class="file" ref="fileInput" @change="onFileSelect"/> -->
                                </div>
                                <div class="form-group">
                                    <b-button variant="primary" style="font-size:20px" :disabled="files.length == 0" @click="handleSaveAgentQ">{{ $t('bookingTx.uploadAgentQ') }}</b-button>
                                </div>
                                <div v-if="fileType == 'pdf'" >
                                    <div  class="file" v-for="(file, index) in files" :key="index" >
                                        <span class="delete" @click="deleteFile(index)">&times;</span>
                                        <vue-pdf-embed :source="file" />
                                    </div>
                                </div>
                                <div v-else class="container">
                                    <div  class="file" v-for="(file, index) in files" :key="index" >
                                        <span  class="delete" @click="deleteFile(index)">&times;</span>
                                        <img :src="file.url" alt=" image "/>
                                    </div>
                                </div>
                                            
                            </div>
                        </div>
                    </b-modal>  
                    <b-modal id="agentQModal" 
                        hide-footer 
                        variant="info" 
                        title-tag="h3"  
                        size="lg" 
                        :title="$t('bookingTx.agentQMsg')" 
                        @hide="resetModalAgentQ"
                    >
                        <h3 class="text-primary mx-3">{{ $t('bookingTx.actAgentQMsg') }}</h3>
                        <div class="d-flex flex-row justify-content-end">
                            <div class="mx-3" >
                                <b-button variant="success" style="font-size:16px"  @click="openFileQ">{{ $t('bookingTx.openFile') }}</b-button>
                            </div>                
                            <div class="mx-3" >
                                <b-button variant="warning" style="font-size:16px" @click="changeFileQ">{{ $t('bookingTx.changeFile') }}</b-button>
                            </div>
                            <div class="ml-3 mr-5" >
                                <b-button variant="danger" style="font-size:16px" @click="resetModalAgentQ">{{ $t('matchTx.cancel') }}</b-button>
                            </div>
                        </div>                
                        <div v-show="!isChangeFile" class=" card">
                            <div v-if="agentQ.fileType == 'pdf'" >
                                <vue-pdf-embed :source="agentQ.url" />
                            </div>
                            <div v-else class="container">
                                <img :src="agentQ.url" alt="Quote Document"/>
                            </div>
                        </div>
                        <div v-show="isChangeFile" class="row col-sm-12 ml-1 gradient-wo"> 
                            <div>
                                <label for="docNo" class="col-form-label pt-0 f-w-600 ml-2" style="font-size:16px;"> {{  $t('bookingTx.docNoQ')}}</label>                                                                       
                                <b-form-input class="mx-2" style="font-size:16px;" v-model="docNo" type = "text" :placeholder="$t('bookingTx.docNoPh')">                            
                                </b-form-input>                        
                            </div>
                            <div class=" card">
                                <div class="top">
                                    <span class="text-primary" style="font-size: 20px;">{{ $t('bookingTx.dragDropQ') }}</span>
                                </div>
                                <div class="drag-area" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">  
                                    <span class="text-info" v-if="!isDragging">
                                        {{ $t('bookingId.dragDropHere') }}
                                            <span class="select" role="button" @click="selectFiles">
                                            {{ $t('bookingId.choose') }}
                                            </span>
                                    </span>
                                    <div v-else class="select">{{ $t('bookingId.dropHere') }}</div>
                                    <input name="file" type="file" accept="application/pdf, image/png, image/jpg" class="file" ref="fileInput" @change="onFileSelect"/>
                                    <!-- <input name="file" type="file" accept="application/pdf" class="file" ref="fileInput" @change="onFileSelect"/> -->
                                </div>
                                <div class="form-group">
                                    <b-button variant="warning" style="font-size:20px" :disabled="files.length == 0" @click="saveChangeQ">{{ $t('bookingTx.saveChange') }}</b-button>
                                </div>
                                <div v-if="fileType == 'pdf'" >
                                    <div  class="file" v-for="(file, index) in files" :key="index" >
                                        <span class="delete" @click="deleteFile(index)">&times;</span>
                                        <vue-pdf-embed :source="file" />
                                    </div>
                                </div>
                                <div v-else class="container">
                                    <div  class="file" v-for="(file, index) in files" :key="index" >
                                        <span  class="delete" @click="deleteFile(index)">&times;</span>
                                        <img :src="file.url" alt=" image "/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-modal>  
                    <b-modal id="agentBModal" 
                        hide-footer 
                        variant="info" 
                        title-tag="h3"  
                        size="lg" 
                        :title="$t('bookingTx.agentBookingTitle')" 
                        @hide="resetModalAgentB"
                    >
                        <h3 class="text-primary mx-3">{{ $t('bookingTx.agentBookingMsg')}}</h3>
                        <div class="d-flex flex-row justify-content-end">
                            <div  v-show="agentB !=''" class="mx-3" >
                                <b-button variant="success" style="font-size:16px"  @click="openFileB">{{ $t('bookingTx.openFile') }}</b-button>
                            </div>                
                            <div v-show="agentB !=''" class="mx-3" >
                                <b-button variant="warning" style="font-size:16px" @click="changeFileB">{{ $t('bookingTx.changeFile') }}</b-button>
                            </div>
                            <div class="ml-3 mr-5" >
                                <b-button variant="danger" style="font-size:16px" @click="resetModalAgentB">{{ $t('matchTx.cancel') }}</b-button>
                            </div>
                        </div>                
                        <div v-show="!isChangeFile && agentB != ''" class=" card">
                            <div v-if="agentB.fileType == 'pdf'" >
                                <vue-pdf-embed :source="agentB.url" />
                            </div>
                            <div v-else class="container">
                                <img :src="agentB.url" alt=" Booking Document"/>
                            </div>
                        </div>
                        <div v-show="isChangeFile || agentB == ''" :class="agentB=='' ? 'row col-sm-12 ml-1 gradient-wy' : 'row col-sm-12 ml-1 gradient-wo' "> 
                            <div>
                                <label for="docNo" class="col-form-label pt-0 f-w-600 ml-2" style="font-size:16px;"> {{  $t('bookingTx.docNoB')}}</label>                                                                       
                                <b-form-input class="mx-2" style="font-size:16px;" v-model="docNo" type = "text" :placeholder="$t('bookingTx.docNoPh')">                            
                                </b-form-input>                        
                            </div>
                            <div class=" card">
                                <div class="top">
                                    <span class="text-primary" style="font-size: 20px;">{{ $t('bookingTx.dragDropB') }}</span>
                                </div>
                                <div class="drag-area" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">  
                                    <span class="text-info" v-if="!isDragging">
                                        {{ $t('bookingId.dragDropHere') }}
                                            <span class="select" role="button" @click="selectFiles">
                                            {{ $t('bookingId.choose') }}
                                            </span>
                                    </span>
                                    <div v-else class="select">{{ $t('bookingId.dropHere') }}</div>
                                    <input name="file" type="file" accept="application/pdf, image/png, image/jpg" class="file" ref="fileInput" @change="onFileSelect"/>
                                </div>
                                <div v-if="agentB ==''" class="form-group">
                                    <b-button variant="primary" style="font-size:20px" :disabled="files.length == 0" @click="handleSaveAgentB">{{ $t('bookingTx.save') }}</b-button>
                                </div>                            
                                <div v-else class="form-group">
                                    <b-button variant="warning" style="font-size:20px" :disabled="files.length == 0" @click="saveChangeB">{{ $t('bookingTx.saveChange') }}</b-button>
                                </div>
                                <div v-if="fileType == 'pdf'" >
                                    <div  class="file" v-for="(file, index) in files" :key="index" >
                                        <span class="delete" @click="deleteFile(index)">&times;</span>
                                        <vue-pdf-embed :source="file" />
                                    </div>
                                </div>
                                <div v-else class="container">
                                    <div  class="file" v-for="(file, index) in files" :key="index" >
                                        <span  class="delete" @click="deleteFile(index)">&times;</span>
                                        <img :src="file.url" alt=" image "/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-modal>  
                </div>
                <div>
                    <vue-html2pdf
                    :show-layout="false"
                    :float-layout="true"
                    :enable-download="false"
                    :preview-modal="true"
                    :paginate-elements-by-height="1400"
                    :pdf-quality="1"
                    :manual-pagination="false"
                    pdf-format="a4"
                    pdf-orientation="portrait"
                    pdf-content-width="800px"
                    :html-to-pdf-options ="htmlToPdfOptions"
                    ref="html2PdfQR"
                    >
                    <section slot="pdf-content">
                            <div class="col-sm-12">
                                <div class="ml-2 mt-1  d-flex flex-row justify-content-between">
                                    <div class="text-center ml-5"><img :src="require('../../assets/images/conex-logoSmall.png')" alt="conex"></div>                              
                                    <h3 class="text-center text-primary mt-2 mb-1">QUOTE REQUEST</h3>
                                    <div class="mr-5">
                                        <div class="row">
                                            <h5 class="text-dark f-w-800 mx-2">Date :</h5>
                                            <span class="text-primary ml-1">{{ $moment().format(" DD-MMM-YYYY") }}</span>   
                                        </div>
                                        <div class="row">
                                            <h5 class="text-dark f-w-800 mx-2">Ref No :</h5>
                                            <span class="text-primary ml-1">{{selItem.bTxId }}</span>   
                                        </div>                            
                                    </div>
                                </div>   
                                <b-row class="ml-4">     
                                    <h4 class="text-dark">Ship Liner : </h4> 
                                    <span class="ml-2 text-primary" style="font-size:18px;"> {{selItem.agent}} </span> 
                                </b-row>                                                 
                            </div>  
                                <b-card-group deck>
                                    <b-card class="mx-4 ">
                                        <b-row>
                                            <h5 class="ml-2 text-dark" >Contact Company :</h5>
                                            <span class="ml-2 text-primary"> {{ selQCompItem.compNameEng }}</span>
                                        </b-row>
                                        <!-- <b-row>
                                            <span class="ml-2 text-dark" >{{ $t('company.address') }} :</span>
                                            <span class="ml-2 text-primary"> {{ selQCompItem.compAddress }}</span>    
                                        </b-row>                                     -->
                                        <b-row class="d-flex flex-row justify-content-between">
                                            <b-row class="mx-2">
                                                <span class="text-dark" >Email :</span>
                                                <span class="ml-2 text-primary"> {{ selQCompItem.contactEmail }}</span>     
                                            </b-row>
                                            <b-row class="mx-3">
                                                <span class="text-dark" >Mobile :</span>
                                                <span class="ml-2 text-primary"> {{ selQCompItem.contactPhone }}</span>     
                                            </b-row>
                                        </b-row>
                                    </b-card>
                                </b-card-group>
                                <div class="ml-4 gradient-wy" >
                                    <div class="d-flex flex-row justify-content-between"> 
                                        <b-col class="my-1">
                                            <h4 class="text-dark">Shipper :</h4>                                                                   
                                            <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.shipper }}</span>   
                                        </b-col>
                                        <b-col class="my-1">
                                            <h4 class="text-dark">Forwarder :</h4>                                                                   
                                            <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.forwarder }}</span>             
                                        </b-col>
                                        <b-col class="my-1">
                                            <h4 class="text-dark">Cargo Owner :</h4>                                                                   
                                            <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.cargoOwner }}</span>                                              
                                        </b-col>
                                    </div>
                                </div>
                                <div class="ml-4 gradient-wy" >
                                    <div class="d-flex flex-row justify-content-between"> 
                                        <b-col>
                                            <h4 class="tex-dark"> Commodity :</h4>                                                                       
                                            <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.commodity }}</span>
                                        </b-col>   
                                        <b-col>
                                            <h4 class="text-dark">Danger Goods  :</h4> 
                                            <!-- <span  :class="`${selItem.dgGDs ? 'ml-2 text-danger' : 'ml-2 text-success' }`" style="font-size:14px;">{{  $t(`bookingTx.${selItem.dgGDs}`) }}</span> -->
                                            <span  :class="`${selItem.dgGDs ? 'ml-2 text-danger' : 'ml-2 text-success' }`" style="font-size:14px;">{{  $t('getQuote.'+ (selItem.dgGDs || 'false')) }}</span>
                                        </b-col>                             
                                        <b-col>
                                            <h4 class="text-dark"> HS-Code :</h4>       
                                            <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.hs6 }}</span>                                                                
                                        </b-col>
                                    </div>
                                </div>  
                                <b-card-group deck>
                                    <b-card class="mx-4 ">
                                        <b-row>
                                            <b-col>
                                                <h4 class="ml-3"> Container : Size - Quatity - Cargo Weight</h4>
                                                <div
                                                    v-for="(sqw, index) in selItem.contSQW"
                                                    :key="index"
                                                    class="select-group-sqw "
                                                >
                                                    <span class="ml-2"># {{index + 1}}:</span>         
                                                    <span class="ml-2">{{ sqw.contSize}} - </span>       
                                                    <span>{{ sqw.contQty}} - </span>      
                                                    <span>{{ sqw.cargoKg}} </span>      
                                                </div> 
                                            </b-col>
                                            <b-col>
                                                <b-row>
                                                    <b-col>
                                                        <h4 class="text-dark" > Type :</h4>                                                                       
                                                        <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.contType}}</span>                                                                       
                                                    </b-col>
                                                    <b-col>
                                                        <h4 class="text-dark"> Grade :</h4>                                                                       
                                                        <span class="ml-2 text-primary" style="font-size:14px;"> {{ selItem.contGrade }}</span>                                                                       
                                                    </b-col>                                    
                                                </b-row>
                                                <b-row class="mt-1 ml-2">
                                                    <h3 class="text-dark">Shipout Date :</h3>
                                                    <span class="ml-2 text-primary" style="font-size:16px;"> {{ $moment(selItem.sdrTS).format('DD-MMM-YYYY') }}</span>
                                                </b-row>  
                                            </b-col>                                           
                                        </b-row>
                                        
                                    </b-card>
                                </b-card-group>                                 
                                <div class="ml-4 gradient-wy" >
                                    <div class="d-flex flex-row justify-content-between"> 
                                        <b-col class="my-1">
                                            <h4 class="tex-dark"> POR-Place of Recept :</h4>                                                                       
                                            <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.POR }}</span>
                                        </b-col>   
                                        <b-col class="my-1">
                                            <h4 class="text-dark"> DEL-Place of Delivery :</h4> 
                                            <span  class="ml-2 text-primary" style="font-size:14px;">{{ selItem.DEL }}</span>
                                        </b-col>                           
                                    </div>
                                </div>  
                                <div class="ml-4 mt-2  gradient-wy" >
                                    <div class="d-flex flex-row justify-content-between my-2"> 
                                        <b-col class="my-2">
                                            <h4 class="text-dark">POL-Port of Loading :</h4> 
                                            <span  class="ml-2 text-primary" style="font-size:14px;">{{ selItem.POL }}</span>
                                        </b-col>                                     
                                        <b-col class="my-2">
                                            <h4 class="tex-dark"> POD-Port of Destination:</h4>                                                                       
                                            <span class="ml-2 text-primary" style="font-size:14px;" >{{ selItem.POD }}</span>
                                        </b-col>
                                    </div>
                                </div>  
                            <div class="mx-4">
                                <h4 class="ml-4 "> Freight: (Preliminary)</h4>
                                <table class="table table-bordered table-striped mx-4">
                                    <tr class="table-warning mr-4">
                                        <th style="font-size: 14px">No</th>
                                        <th style="font-size: 14px">Size</th>
                                        <th>Qty</th>       
                                        <th>Currency</th>   
                                        <th>Amount</th>
                                        <th class="gradient-yg">USD</th>                                                                           
                                        <th >Rate</th>
                                    </tr>
                                    <tr v-for="( f, i) in selItem.fItems"
                                        :key="f.id"
                                    >
                                        <td style="font-size: 12px">{{ i+1 }}</td>                                              
                                        <td>{{f.contSize}}</td>
                                        <td>{{ f.contQty }}</td>
                                        <td>{{ f.fCurr }}</td>
                                        <td>{{ f.fCalc }}</td>   
                                        <td class="gradient-yg">{{ f.fUSD }}</td>                                    
                                        <td>{{ f.fRate }}</td>  
                                    </tr>
                                    <tr>
                                        <td></td><td></td><td></td><td></td><td>Total-USD = </td><td class="gradient-yg" style="font-weight: bold;">{{ selItem.fUSD }}</td>
                                    </tr>
                                </table>
                            </div>       
                            <div class="mx-4">
                                <h4 class="ml-4 "> Surcharge : (Preliminary)</h4>
                                <table class="table table-bordered table-striped mx-4">
                                    <tr class="table-warning">
                                        <th style="font-size: 14px">No</th>
                                        <th style="font-size: 14px">Code</th>
                                        <th>Rate Base</th>                                    
                                        <th class="gradient-gy">Currency</th>
                                        <th>Amount</th>
                                        <th class="gradient-yg">USD</th>  
                                        <th>Rate</th>
                                        <th>{{$t("freight.L20")}}</th>
                                        <th>{{$t("freight.L40")}}</th>
                                        <th>{{$t("freight.L40HC")}}</th>
                                    </tr>
                                    <tr v-for="( s, i) in selItem.surcharge"
                                        :key="s.id"
                                    >
                                        <td style="font-size: 12px">{{ i+1 }}</td>                                              
                                        <td>{{s.surCode}}</td>
                                        <td>{{ s.rateBase }}</td>                                
                                        <td>{{ s.sCurr }}</td>
                                        <td>{{ s.surCalc }}</td>
                                        <td class="gradient-yg">{{ s.surUSD }}</td>                                
                                        <td>{{ s.surRate }}</td>
                                        <td>{{ s.L20 }}</td>
                                        <td>{{ s.L40 }}</td>                                
                                        <td>{{ s.L40HC }}</td>
                                    </tr>
                                    <tr>
                                        <td></td><td></td><td></td><td></td><td>Total-USD = </td><td class="gradient-yg" style="font-weight:bold">{{ selItem.surUSD }}</td><td></td><td></td><td></td>
                                    </tr>
                                </table>
                            </div> 
                            <div class="divider mt-1 mx-4"> </div>                
                    </section>
                    </vue-html2pdf>
                </div>
            </div>
        </b-container>
    </div>
  </template>
  <script>
  
  import { getData, uploadImage,compNameEngByCompId,getDataActive, updateBookingTx2StepN, saveWithId, mergeObj} from "../../firebase"
  import {rejAgentOptions, contGrade} from '../../constants/config'
  // import {exportXlsx ,getRandomInt} from "../../utilities/util" 
    export default {
      name: 'agentBookingTx',
      data() {
        return {
            asOf : this.$moment().format( "HH:mm,  DD-MM-YYYY"),
            docNo : '',
            files : [],
            fileType : '',
            isDragging: false,
            isChangeFile : false,
            agentQ : '',
            agentB : '',
            selItem : '',  
            selQCompItem : '',
            selBTxId : '',
            selAgent : '',
            rejAgentOptions : rejAgentOptions,
            selectedReason : '',
            compId : '',
            portId : '',
            pName : '',
            cntry : '',
            selectedSurCode : '',
            surDesc : '',
            remark : '',
            jbBTx:[],
            msgr: [],
            msgrInput : '',        
            commodity : '',
            dgGDs : false,
            hs6 : '',
            shipper : '',
            forwarder : '',
            POR : '',
            DEL : '',
            cargoOwner : '',
            shipDateReqr : '',
            format: "yyyy-MM-dd",
            disabledDates: {
                to: new Date(Date.parse(new Date())+86400000),
            },
            contGrade : '',
            optionsContGrade : contGrade, 
            itemsFght : [],
            fieldsFght: [
                { key: 'contSize', label: this.$t('container.contSize'), sortable: true , variant: 'info'},                                                 
                { key: 'contQty', label: this.$t('getQuote.contQty'), sortable: true , variant: 'info'},  
                { key: 'fRate', label: this.$t('freight.fghtRate'), sortable: true , variant: 'info'}, 
                { key: 'fCurr', label: this.$t('freight.currency'), sortable: true, variant: 'primary' },  
                { key: 'fCalc', label: this.$t('freight.amount'), sortable: true, variant: 'primary' },        
                { key: 'fUSD', label: this.$t('freight.USD'), sortable: true, variant: 'warning' },         
                { key: 'cargoKg', label: this.$t('getQuote.cargoKg'), sortable: true , variant: 'info'},  
    
            ],
            itemsSur : [],
            fieldsSur : [
                { key: 'detailsSurCode', label: this.$t('surcharge.surCode'), sortable: true , variant: 'info'},
                { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, variant: 'primary' },   
                { key: 'rateBase', label: this.$t('surcharge.rateBase'), variant: 'primary' },        
                { key: 'sCurr', label: this.$t('freight.currency'), variant: 'primary' },    
                { key: 'surCalc', label: this.$t('freight.amount'), variant: 'primary' },   
                { key: 'surUSD', label: this.$t('freight.USD'), variant: 'warning' },     
                { key: 'surRate', label: this.$t('surcharge.surRate'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                }}, 
                { key: 'L20', label: this.$t('freight.L20'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                    }
                }, 
                { key: 'L40', label: this.$t('freight.L40'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                }}, 
                { key: 'L40HC', label: this.$t('freight.L40HC'), sortable: true , variant: 'secondary',
                    formatter: value => {
                        return parseInt(value) == 0 ? "N/A" : value
                }}, 
            ],
            isBusy: false,     
            items: [],             
            fields: [
                { key: 'index', label: this.$t('seal.item'), sortable: true , variant: 'primary'},                 
                { key: 'bTxId', label: this.$t('bookingTx.bTxId'), sortable: true, variant: 'info',},              
                { key: 'fghtCat', label: this.$t('freight.fghtCat'), sortable: true , variant: 'info',},       
                { key: 'sctCode', label: this.$t('freight.sctCode'), sortable: true , variant: 'info',}, 
                { key: 'sdrTS', label: this.$t('getQuote.shipDateReqr'), sortable: true , variant: 'success', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},              
                { key: 'POR', label: this.$t('bookingTx.POR'), sortable: true , variant: 'success',},                                
                { key: 'detailsPOL', label: this.$t('getQuote.POL'), sortable: true , variant: 'success'},  
                { key: 'detailsPOD', label: this.$t('getQuote.POD'), sortable: true , variant: 'success'}, 
                { key: 'DEL', label: this.$t('bookingTx.DEL'), sortable: true , variant: 'success',},       
                { key: 'jbBTx', label: this.$t('matchTx.jobStatus'), sortable: true, variant: 'danger',},  
                { key: 'detailsCommodity', label: this.$t('getQuote.commodity'), sortable: true , variant: 'primary'}, 
                { key: 'contSQWArr', label: this.$t('getQuote.contSQW'), sortable: true, variant: 'primary',thStyle:{width:'220px'} },
                { key: 'contType', label: this.$t('matchTx.contType'), sortable: true , variant: 'primary',                     
                    formatter: value => {
                        return value.toUpperCase()
                }}, 
                { key: 'contGrade', label: this.$t('matchTx.gradeTh'), sortable: true, variant: 'primary' }, 
                { key: 'curr', label: this.$t('freight.currency'), sortable: true, variant: 'warning' },                             
                { key: 'detailsFght', label: this.$t('freight.header'), sortable: true , variant: 'warning'},  
                { key: 'detailsSur', label: this.$t('surcharge.header'), sortable: true , variant: 'warning'}, 
                { key: 'actCust', label: this.$t('matchTx.actions'), variant: 'secondary', thStyle:{width:'220px'} },     
                { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
                formatter: value => {
                    return this.$moment(value).format("DD-MM-YY @ HH:mm")
                }},           
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'timestamp',
            sortDesc: true,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
        }
      },
      computed: {
        sortOptions() {
          // Create an options list from our fields
          return this.fields
            .filter(f => f.sortable)
            .map(f => {
              return { text: f.label, value: f.key }
            })
        },
        htmlToPdfOptions(){
        return {
          margin: 0,
          filename: `QR-${this.selItem.bTxId}`,
          image: {
            type: 'jpg', 
            quality: 0.98
          },
          enableLinks: false,
          html2canvas: {
            scale: 1,
            useCORS: true
          },
        }
      },
      },
      
      mounted() {
        this.compId= localStorage.getItem("compId")
        compNameEngByCompId(this.compId , (nameEng)=>{
            this.selAgent = nameEng
            getDataActive('BookingTx', 'agent', nameEng , (res)=>{
                this.items = res
                this.totalRows = res.length
            })
        })
      },
      methods: {
        formatter(value) {
              return value.toUpperCase()
          },
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
        async refreshBookingTx() {
            this.isBusy = true
            await getDataActive('BookingTx', 'agent', this.selAgent, (res)=>{
                this.items = res
                this.totalRows = res.length
                this.isBusy = false
            })
            this.asOf = this.$moment().format( "HH:mm,  DD-MM-YYYY") 
            this.docNo = ''
            this.files = []
            this.selBTxId = ''
            this.fileType = ''
            this.isChangeFile = false
            this.agentQ = ''
            this.agentB = ''
        },
        async openModalJbBTx(item) {
          await getData( 'jbBTx' , 'id' , item.bTxId, (res)=>{
              this.jbBTx = res.sort((a,b)=>
              b.timestamp - a.timestamp
            )
              this.$root.$emit('bv::show::modal', "jbBTxModal")
          })
        },
        resetModalJbBTx() {
          this.jbBTx = []
          this.$root.$emit('bv::hide::modal', "jbBTxModal")
        },
        async openModalDetailsCommodity(item) {
          this.commodity = item.commodity
          this.dgGDs = item.dgGDs
          this.hs6 = item.hs6
          this.$root.$emit('bv::show::modal', "detailsCommodityModal")
        },
        resetModalDetailsCommodity() {
          this.commodity = ''
          this.hs6 = ''
          this.dgGDs = false
          this.$root.$emit('bv::hide::modal', "detailsCommoditytModal")
        },      
        async openModalDetailsPOL(item, index, button) {
          await getData( 'Port' ,'id' , item.POL, (res)=>{
            this.portId = res[0].id
            this.pName = res[0].pName.trim()
            this.cntry = res[0].cntry
          })
          this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
        },
        async openModalDetailsPOD(item, index, button) {
          await getData( 'Port' ,'id' , item.POD, (res)=>{
            this.portId = res[0].id
            this.pName = res[0].pName.trim()
            this.cntry = res[0].cntry
          })
          this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
        },
        resetModalDetailsPort() {
          this.portId = ''
          this.pName = ''
          this.cntry = ''
          this.$root.$emit('bv::hide::modal', "detailsPortModal")
        }, 
        async openModalDetailsFght(item, index, button) {
            this.itemsFght = item.fItems
            // this.totalRowsFght = item.fItems.length
          this.$root.$emit('bv::show::modal', "detailsFghtModal" , button)
        },
        resetModalDetailsFght() {
            this.itemsFght = []
            this.$root.$emit('bv::hide::modal', "detailsFghtModal")
        },
        async openModalDetailsSur(item, index, button) {
            this.itemsSur = item.surcharge
            // this.totalRowsSur = item.surcharge.length
          this.$root.$emit('bv::show::modal', "detailsSurModal" , button)
        },
        resetModalDetailsSur() {
            this.itemsSur = []
            this.$root.$emit('bv::hide::modal', "detailsSurModal")
        },      
        async openModalDetailsSurCode(item, index, button) {
          await getData( 'SurCode' ,'id' , item.surCode, (res)=>{
            this.selectedSurCode= res[0].id
            this.surDesc = res[0].surDesc
            this.remark = res[0].remark
          })
          this.$root.$emit('bv::show::modal', "detailsSurCodeModal" , button)
        },
        resetModalDetailsSurCode() {
            this.selectedSurCode = ''
            this.surDesc = ''
            this.remark = ''
            this.$root.$emit('bv::hide::modal', "detailsSurCodeModal")
        },  
        async actReject(item) {
          this.selBTxId = item.bTxId 
          this.selQCompId = item.qCompId,
          this.$root.$emit('bv::show::modal', "rejAgentModal")
        },
        async clickYes_RejAgent(){
          let ts = Date.parse(new Date())
          await updateBookingTx2StepN('BookingTx',this.selBTxId , 1.2 ).then(async()=>{
            await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
              id : this.selBTxId,
              msgr : `${this.selAgent} @Reject: ${this.msgrInput}`,
              timestamp : ts,
            })
            await this.refreshBookingTx()
            this.$root.$emit('bv::hide::modal', "rejAgentModal")
          })     
        },
        resetModalRejAgent(){
            this.selBTxId = ''
            this.selQCompId = '',
            this.msgrInput = '',
            this.selectedReason = ''
            this.$root.$emit('bv::hide::modal', "rejAgentModal")
        },       
        
        actAccept(item) {
            this.selBTxId = item.bTxId 
            this.$root.$emit('bv::show::modal', "acceptAgentModal")
        },
        resetModalAcceptAgent(){
            this.selBTxId = ''
            this.$root.$emit('bv::hide::modal', "acceptAgentModal")
        },    
        async saveChangeQ(){
            let msg = 'completed'
            if (this.files.length === 0){
                msg = 'bookingTx.addFileQ'
            } else if (this.files.length > 1){
                msg = 'bookingId.oneFileOnly'
            } else if (this.docNo === ''){
                msg = 'bookingTx.addDocNo'
            }  
            if (msg === 'completed'){
                    await this.mergeAgentQ(async (res)=>{
                        if (res == 'success') {
                            let ts = Date.parse(new Date())
                            await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
                            id : this.selBTxId,
                            msgr : `${this.selAgent} @Change Quote`,
                            timestamp : ts,
                        })
                        await this.refreshBookingTx()
                        this.$root.$emit('bv::hide::modal', "agentQModal")
                        this.$toasted.show(this.$t('bookingTx.successMerge'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000}); 
                        } else {
                            this.$toasted.show('Merge is not success', {theme: 'bubble', position: 'bottom-center', type: 'danger' , duration: 5000}); 
                        }
                    })
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        }, 
        async handleSaveAgentQ(){
            let msg = 'completed'
            if (this.files.length === 0){
                msg = 'bookingTx.addFileQ'
            } else if (this.files.length > 1){
                msg = 'bookingId.oneFileOnly'
            } else if (this.docNo === ''){
                msg = 'bookingTx.addDocNo'
            }  
            if (msg === 'completed'){
                await updateBookingTx2StepN('BookingTx' , this.selBTxId, 2).then(async()=>{
                    await this.mergeAgentQ( async(res)=>{
                        if (res== 'success') {
                            await this.refreshBookingTx()
                            this.$root.$emit('bv::hide::modal', "acceptAgentModal")
                            this.$toasted.show(this.$t('bookingTx.successMerge'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000}); 
                        } else {
                            this.$toasted.show('Merge is not success', {theme: 'bubble', position: 'bottom-center', type: 'danger' , duration: 5000}); 
                        }
                    })

                })
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        }, 
        async mergeAgentQ( cb ){
            await uploadImage('agentQ', this.files[0], async(url)=>{ 
                await mergeObj('BookingTx', this.selBTxId, {
                    agentQ :{
                        no : this.docNo || '',
                        url : url,
                        fileType : this.fileType,
                        ts : Date.parse(new Date())
                    }
                })      
                cb('success')          
            })   
        },

        async handleSaveAgentB(){
            let msg = 'completed'
            if (this.files.length === 0){
                msg = 'bookingTx.addFileB'
            } else if (this.files.length > 1){
                msg = 'bookingId.oneFileOnly'
            } else if (this.docNo === ''){
                msg = 'bookingTx.addDocNo'
            }  
            if (msg === 'completed'){
                await updateBookingTx2StepN('BookingTx' , this.selBTxId, 4).then(async()=>{
                    await this.mergeAgentB(async(res)=>{
                        if (res='success') {
                            await this.refreshBookingTx()
                            this.$root.$emit('bv::hide::modal', "agentBModal")
                            this.$toasted.show(this.$t('bookingTx.successMerge'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000}); 
                        } else {
                            this.$toasted.show('Merge is not success', {theme: 'bubble', position: 'bottom-center', type: 'danger' , duration: 5000}); 
                        }
                    })
                })
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        }, 
        async saveChangeB(){
            let msg = 'completed'
            if (this.files.length === 0){
                msg = 'bookingTx.addFileQ'
            } else if (this.files.length > 1){
                msg = 'bookingId.oneFileOnly'
            } else if (this.docNo === ''){
                msg = 'bookingTx.addDocNo'
            }  
            if (msg === 'completed'){
                    await this.mergeAgentB(async (res)=>{
                        if (res == 'success') {
                            let ts = Date.parse(new Date())
                            await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
                            id : this.selBTxId,
                            msgr : `${this.selAgent} @Change Booking`,
                            timestamp : ts,
                        })
                        await this.refreshBookingTx()
                        this.$root.$emit('bv::hide::modal', "agentBModal")
                        this.$toasted.show(this.$t('bookingTx.successMerge'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000}); 
                        } else {
                            this.$toasted.show('Merge is not success', {theme: 'bubble', position: 'bottom-center', type: 'danger' , duration: 5000}); 
                        }
                    })
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        }, 
        async mergeAgentB( cb){
            await uploadImage('agentB', this.files[0], async(url)=>{ 
                await mergeObj('BookingTx', this.selBTxId, {
                    agentB :{
                        no : this.docNo || '',
                        url : url,
                        fileType : this.fileType,
                        ts : Date.parse(new Date())
                    }
                })      
                cb('success')          
            })   
        },
        selectFiles(){
            this.$refs.fileInput.click()
        },
        onFileSelect(event){
            const selFiles = event.target.files;
            const acceptFile = ["jpeg", "png", "pdf"]
            // console.log(`selFiles => ${JSON.stringify(event.target.files)}`)
            if (selFiles.length === 0) return     
            for (let i = 0; i < selFiles.length; i++) {
                // console.log(`bookingId, selFiles[i] => ${selFiles[i].type}`)
                if (!acceptFile.includes( selFiles[i].type.split("/")[1])) continue;
                if (!this.files.some((e)=> e.name === selFiles[i].name)){
                   this.fileType = selFiles[i].type.split("/")[1] 
                   this.files.push({name:selFiles[i].name, url: URL.createObjectURL(selFiles[i])});  // for Multiple images
                   // this.files[0] = {name:selFiles[i].name, url: URL.createObjectURL(selFiles[i])}  // replace for 1 last image only.
                }
            }  
            // console.log(`files => ${JSON.stringify(this.files)}`)
        },
        deleteFile(index){
            this.files.splice(index , 1)
        },
        onDragOver(event){
            event.preventDefault();
            this.isDragging = true
            event.dataTransfer.dropEffect = "copy";
        },
        onDragLeave(event){
            event.preventDefault();
            this.isDragging = false
        },
        onDrop(event){
            event.preventDefault();
            this.isDragging = false;
            const acceptFile = ["jpeg" ,"png", "pdf"]
            const selFiles = event.dataTransfer.files;
            for (let i = 0; i < selFiles.length; i++) {
                // console.log(`bookingId, on Drop, selFiles[i] => ${selFiles[i].type}`)
                // if (selFiles[i].type.split("/")[1] != "pdf") continue;
                if (!acceptFile.includes( selFiles[i].type.split("/")[1])) continue;
                if (!this.files.some((e)=> e.name === selFiles[i].name)){
                    this.fileType = selFiles[i].type.split("/")[1]
                    this.files.push({name:selFiles[i].name, url: URL.createObjectURL(selFiles[i])});  // for Multiple images
                    // this.files[0] = {name:selFiles[i].name, url: URL.createObjectURL(selFiles[i])} // replace for 1 last image only.
                }
            }
        },



        async actPreQInfo(item){
            this.selItem = item
            await getData( 'Company' , 'compId', item.qCompId, (res)=>{
                this.selQCompItem = res[0]
            }).then(()=>{
                this.$refs.html2PdfQR.generatePdf()
            })
        },
        async actMsgr(item){
          this.selBTxId = item.bTxId
          await getData( 'messenger' , 'id' , item.bTxId, (res)=>{
              this.msgr = res.sort((a,b)=>
              b.timestamp - a.timestamp
            )
            //   console.log(`Msgr = >${item.bTxId} - ${JSON.stringify(res , null , 2)}`)
              this.$root.$emit('bv::show::modal', "msgrModal")
          })
        },
        resetModalMsgr() {
          this.msgr = []
          this.selBTxId = ''
          this.msgrInput = ''
          this.$root.$emit('bv::hide::modal', "msgrModal")
        },
        async clickSend_Msgr(){
          let ts = Date.parse(new Date())
          await saveWithId('messenger', `${this.selBTxId}-${ts}`, {
            id : this.selBTxId,
            msgr : `${this.selAgent} : ${this.msgrInput}`,
            timestamp : ts,
          }).then(()=>{
            this.resetModalMsgr()
          })
        },    
        
        actAgentQ(item){
            if (item.agentQ == '') {
                // need to re-add quote
                this.$toasted.show( 'Quote is not found.', {theme: 'bubble', position: 'bottom-center', type: 'warning' , duration: 5000});   
            } else {
                this.selBTxId = item.bTxId
                this.agentQ = item.agentQ
                this.$root.$emit('bv::show::modal', "agentQModal")
            }
        },
        resetModalAgentQ(){
            this.selBTxId = ''
            this.msgrInput = '',
            this.selectedReason = ''
            this.docNo = ''
            this.files = []
            this.fileType = ''
            this.isChangeFile = false
            this.agentQ = ''
            this.$root.$emit('bv::hide::modal', "agentQModal")
        },    
        openFileQ() {
            this.isChangeFile = false
            window.open(this.agentQ.url)
        },
        changeFileQ() {
            this.isChangeFile = true
        },

        actAgentB(item){
            this.selBTxId = item.bTxId
            this.agentB = item.agentB
            this.$root.$emit('bv::show::modal', "agentBModal")
        },
        resetModalAgentB(){
            this.selBTxId = ''
            this.docNo = ''
            this.files = []
            this.fileType = ''
            this.isChangeFile = false
            this.agentB = ''
            this.$root.$emit('bv::hide::modal', "agentBModal")
        },  
        openFileB() {
            // window.location.href= item.fileUri
            window.open(this.agentB.url)
        },
        changeFileB() {
            this.isChangeFile = true
        },  

      }
    }
  </script>
  <style scoped>
.my-loop-item {
  padding: 5px;
  margin-bottom: 2px;
  border: 1px solid #ccc;
}
.my-loop-item:first-child {
  background: linear-gradient(135deg, white, pink);
  font-weight: bold;
  font-size: 16px;
  border: 2px solid #00bcd4;
}
    .card{
        width:100%;
        padding:2px;
        background:  rgb(184, 246, 245);
        border-radius: 5px;
        overflow: hidden;
    }
    .card .top{
        text-align: center;
    }
    .card p{
        font-weight: bold;
        color: #fe0000;
    }
    .card button{
        outline: 0;
        border: 0;
        color : #ffff;
        border-radius: 4px;
        font-weight: 40;
        padding: 8px 13px;
        width: 100%;
        background: #fe0000;
    }
    .card .drag-area{
        height : 100px;
        border-radius: 5px;
        border: 2px dashed #00d4fe;
        background: #f4f3f9;
        color : #fe0000;
        display:flex;
        justify-content: center;
        align-items: center;
        user-select: center;
        -webkit-user-select: none;
        margin-top: 5px;
    }
    .card .darg-area .visible{
        font-size: 18px
    }
    .card .select{
        color: #5256ad;
        margin-left: 5px;
        cursor: pointer;
        transition: 0.4s;
    }
    .card .select :hover{
        opacity: 0.6;
    }
    .card .container{
        height : auto;
        width: 100%;
        display:flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        max-height: 100%;
        position: relative;
        margin-bottom: 8px;
        padding-top: 15px;
    }
    .card .container .file{
        width: 100%;
        margin-right: 5px;
        height: 100%;
        position: relative;
        margin-bottom: 8px;
    }
    .card .container .image img{
        width: 100%;
        height: 100%;
        border-radius: 5px;
    }
    .card .container .file span{
        position:absolute;
        top: -2px;
        right: 9px;
        font-size: 30px;
        cursor: pointer;
    }
    .card input,
    .card .drsg-area .on-drop,
    .card .drag-area.dragover .visible{
        display: none;
    }
    .delete{
        z-index: 999;
        color:#fe0000;
        font-size:xx-large;
        display:flex;
        justify-content: flex-end;
        align-items: flex-end;
    }
    .select-group {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding: 10px;
        border: 1px solid #eee;
        border-radius: 4px;
    }
    .select-group-sqw {
        display: flex;
        align-items: flex-start;
        margin-bottom: 2px;
        padding: 2px;
        border: 1px solid #eee;
        border-radius: 4px;
    }
    .divider {
      height: 1px;
      background-color: #0f0f0f;
      margin:5px
    }
    .display-image {
      width: 100%;
      height: 450px;
      object-fit: scale-down;
      border-radius: 8px;
      background-color: #f5f5f5;
    }
   .gradient-wo {
     background: linear-gradient(135deg, white, orange);
   }
   .gradient-yg {
     background: linear-gradient(135deg, yellow, green);
   }
   .gradient-wy {
     background: linear-gradient(135deg, white, yellow);
   }
   .gradient-wp {
     background: linear-gradient(135deg, white, pink);
   }
   .gradient-wb {
     background: linear-gradient(45deg, white, blue)
   }
   /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 17px;
  }
  
  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN OFF */
    background-color: #ccc; /* Example: Gray when off */
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 13px;
    width: 13px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  /* Change background color of the slider when checked (ON state) */
  input:checked + .slider {
    /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN ON */
    background-color: #2196F3; /* Example: Blue when on */
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
  }
  
  /* Rounded sliders */
  .slider.round {
    border-radius: 17px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }
  
  .display-image {
    width: 100%;
    height: 450px;
    object-fit: contain;
    border-radius: 8px;
    background-color: #f5f5f5;
  }
  .dashboard {
    padding: 10px;
    max-width: 100%;
    overflow-x: hidden;
  }
  .image-scroll-container {
    position: relative;
    margin: 20px 0;
  }
  
  .image-scroll {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    width: 100%;
  }
  
  .image-scroll::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome/Safari */
  }
  
  .image-item {
    flex: 0 0 100%;
    scroll-snap-align: start;
    position: relative;
    padding: 0 5px;
    box-sizing: border-box;
  }
  
    .image-counter {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 14px;
  }
  
  .no-images {
    text-align: center;
    width: 100%;
    padding: 50px 0;
    color: #666;
    font-style: italic;
    font-size: 16px;
  }
  .tableInfo {
    text-align: center;
    color: #021001;
    font-size: 16px;
  }
  
  .scroll-controls {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  
  .scroll-btn {
    background-color: #42b983;
    color: white;
    border: none;
    padding: 8px 15px;
    margin: 0 5px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
  }
  </style>